import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

export default function Hero() {
  const scrollToFeatures = (e) => {
    e.preventDefault()
    document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section className="landing-hero">
      <div className="landing-hero__bg-orb landing-hero__bg-orb--1" />
      <div className="landing-hero__bg-orb landing-hero__bg-orb--2" />

      <div className="landing-hero__container">
        <div className="landing-hero__content">
          <h1 className="landing-hero__title">
            Vos finances personnelles,<br />
            <span>enfin sous contrôle.</span>
          </h1>
          <p className="landing-hero__subtitle">
            Comptes, budget, analytics, tout ce qu'il faut pour gérer votre argent simplement. Gratuit, sécurisé, et conçu pour vous.
          </p>
          <div className="landing-hero__ctas">
            <a href={process.env.REACT_APP_APP_URL + '/nouveau_compte'} className="landing-hero__cta landing-hero__cta--primary">
              Commencer gratuitement <FontAwesomeIcon icon={faArrowRight} />
            </a>
            <a href="#features" onClick={scrollToFeatures} className="landing-hero__cta landing-hero__cta--outline">
              Découvrir
            </a>
          </div>
        </div>

        <div className="landing-hero__mockup-wrapper">
          <div className="landing-hero__mockup">
            <div className="landing-hero__mockup-header">
              <div className="landing-hero__mockup-header__dot landing-hero__mockup-header__dot--red" />
              <div className="landing-hero__mockup-header__dot landing-hero__mockup-header__dot--yellow" />
              <div className="landing-hero__mockup-header__dot landing-hero__mockup-header__dot--green" />
              <span className="landing-hero__mockup-header__title">Mes comptes</span>
            </div>

            <div className="landing-hero__mockup-accounts">
              <div className="landing-hero__mockup-account">
                <div className="landing-hero__mockup-account__name">Compte courant</div>
                <div className="landing-hero__mockup-account__balance">2 450,00 €</div>
              </div>
              <div className="landing-hero__mockup-account">
                <div className="landing-hero__mockup-account__name">Livret A</div>
                <div className="landing-hero__mockup-account__balance landing-hero__mockup-account__balance--green">8 320,00 €</div>
              </div>
              <div className="landing-hero__mockup-account">
                <div className="landing-hero__mockup-account__name">Compte joint</div>
                <div className="landing-hero__mockup-account__balance">1 680,00 €</div>
              </div>
            </div>

            <div className="landing-hero__mockup-chart">
              <div className="landing-hero__mockup-chart__title">Dépenses — 6 derniers mois</div>
              <div className="landing-hero__mockup-chart__bars">
                {[65, 45, 80, 55, 70, 40].map((h, i) => (
                  <div
                    key={i}
                    className="landing-hero__mockup-chart__bar"
                    style={{
                      height: `${h}%`,
                      background: i === 2 ? 'var(--dark-solid)' : 'var(--dark-element-hovered)',
                    }}
                  />
                ))}
              </div>
            </div>

            <div className="landing-hero__mockup-transactions">
              <div className="landing-hero__mockup-transactions__title">Dernières transactions</div>
              {[
                { label: 'Carrefour', category: 'Alimentation', amount: '-82,40 €', negative: true },
                { label: 'Salaire', category: 'Revenus', amount: '+2 150,00 €', negative: false },
                { label: 'Netflix', category: 'Loisirs', amount: '-13,49 €', negative: true },
              ].map((tx, i) => (
                <div className="landing-hero__mockup-transactions__row" key={i}>
                  <div>
                    <div className="landing-hero__mockup-transactions__label">{tx.label}</div>
                    <div className="landing-hero__mockup-transactions__category">{tx.category}</div>
                  </div>
                  <div className={`landing-hero__mockup-transactions__amount landing-hero__mockup-transactions__amount--${tx.negative ? 'negative' : 'positive'}`}>
                    {tx.amount}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
